import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { industries } from '../lib/mock';
import SEO from '../components/SEO';

export default function Industries() {
  return (
    <div className="pt-20 min-h-screen bg-slate-50">
      <SEO 
        title="Industries We Serve - Water Treatment Solutions"
        description="Customized water treatment plant solutions for Manufacturing, Textile, Pharmaceutical, Chemical, Food & Beverage and Municipal sectors across India."
        keywords="water treatment for textile industry, ETP for pharma, STP for manufacturing, industrial water treatment solutions, food and beverage water treatment, municipal STP plant"
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://bgtechnochem.com/" },
            { "@type": "ListItem", "position": 2, "name": "Industries", "item": "https://bgtechnochem.com/industries" }
          ]
        }}
      />
      
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-6 text-slate-900">Industries We Serve</h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            From large-scale manufacturing to commercial complexes, we provide tailored water solutions for diverse sectors.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry, index) => {
              const Icon = industry.icon;
              return (
                <Card key={index} className="hover:shadow-xl transition-shadow border-none bg-white">
                  <CardContent className="p-8 flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                      <Icon className="w-8 h-8 text-primary" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">{industry.name}</h3>
                    <p className="text-slate-600">
                      Specialized treatment solutions designed to meet the unique effluent challenges of the {industry.name.toLowerCase()} sector.
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Global Reach Map Placeholder */}
      <section className="py-20 bg-slate-900 text-white text-center">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-6">Serving Clients Globally</h2>
          <p className="text-slate-400 mb-10">
            While rooted in Punjab, our expertise has no boundaries. We have successfully executed projects across India and international markets.
          </p>
          <div className="w-full h-[400px] bg-slate-800 rounded-2xl flex items-center justify-center border border-slate-700">
            <span className="text-slate-500 font-mono text-lg">Global Project Map Visualization</span>
          </div>
        </div>
      </section>
    </div>
  );
}
